(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-floating-cta"] && !Shopify.designMode) return;
  try {
    // テーマエディターのセクション再描画後も初期化されるようカスタム要素化する
  if (!customElements.get('product-floating-cta')) {
    customElements.define(
      'product-floating-cta',
      class ProductFloatingCta extends HTMLElement {
        connectedCallback() {
          this.ctaButton = this.querySelector('[data-product-floating-cta-button]');
          this.targetId = this.dataset.targetButton;

          if (!this.ctaButton || !this.targetId) return;

          // SP表示のみ対象（Dawnのモバイル幅と同じ）
          this.spMediaQuery = window.matchMedia('(max-width: 749px)');

          this.update = this.update.bind(this);
          this.onClick = this.onClick.bind(this);

          this.ctaButton.addEventListener('click', this.onClick);
          window.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.update);
          window.removeEventListener('resize', this.update);
        }

        // 通常のカートに追加ボタンは都度取得する（バリアント変更で要素が差し替わるため）
        getRealButton() {
          return document.getElementById(this.targetId);
        }

        update() {
          const realButton = this.getRealButton();

          // SP以外・ボタン非表示・売り切れ(disabled)・ボタンより下へスクロールしていないときは固定CTAを出さない
          // （カートに追加ボタンが画面上端より上へスクロールアウトしたときだけ表示する）
          if (
            !this.spMediaQuery.matches ||
            !realButton ||
            realButton.disabled ||
            realButton.offsetParent === null ||
            realButton.getBoundingClientRect().bottom > 0
          ) {
            this.hidden = true;
            return;
          }

          // ラベルを通常ボタンに合わせる
          const realLabel = realButton.querySelector('span');
          const ctaLabel = this.ctaButton.querySelector('span');
          if (realLabel && ctaLabel) ctaLabel.textContent = realLabel.textContent.trim();

          this.hidden = false;
        }

        // 固定ボタンのローディング表示を通常ボタンに合わせて切り替える
        setLoading(isLoading) {
          this.ctaButton.classList.toggle('loading', isLoading);
          this.ctaButton.setAttribute('aria-disabled', isLoading);
          const ctaSpinner = this.ctaButton.querySelector('.loading__spinner');
          if (ctaSpinner) ctaSpinner.classList.toggle('hidden', !isLoading);
        }

        // 押下で通常ボタンと同じ処理（そのままカートに追加）を実行する
        onClick() {
          const realButton = this.getRealButton();
          if (!realButton || realButton.disabled) return;
          // 処理中の二重押下は無視する
          if (realButton.classList.contains('loading')) return;

          this.setLoading(true);

          // 通常ボタンのローディング終了（loadingクラス除去）を監視して固定ボタンにも反映する
          const observer = new MutationObserver(() => {
            if (!realButton.classList.contains('loading')) {
              this.setLoading(false);
              observer.disconnect();
            }
          });
          observer.observe(realButton, { attributes: true, attributeFilter: ['class'] });

          realButton.click();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
